import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import palette from "assets/theme/base/palette";

const Refresh = () => {
  const { t } = useTranslation();
  const { signOut } = useAuthenticator((context) => [context.user]);

  const logOutHandler = () => {
    localStorage.removeItem("session");
    localStorage.removeItem("referral");
    localStorage.removeItem("lastPaymentReminderDate");
    signOut();
  };

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <MDBox
        sx={{
          background: `linear-gradient(135deg, ${palette.brand[400]} 0%, ${palette.brand[600]} 100%)`,
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <MDBox
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: "rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Icon sx={{ fontSize: 38, color: "#fff" }}>lock_clock</Icon>
        </MDBox>
        <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#fff" }}>
          {t("session.expiredTitle") || "Session Expired"}
        </MDTypography>
      </MDBox>

      <DialogContent sx={{ px: 4, py: 3, textAlign: "center" }}>
        <MDTypography variant="body2" color="text" lineHeight={1.75} mb={0.5}>
          {t("session.expiredMessage")}
        </MDTypography>
        <MDTypography variant="body2" color="text" lineHeight={1.75}>
          {t("session.refreshOrLogin")}{" "}
          <MDTypography
            component="span"
            variant="body2"
            fontWeight="bold"
            sx={{ color: palette.brand[500], cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
            onClick={logOutHandler}
          >
            {t("session.login")}
          </MDTypography>{" "}
          {t("session.toContinue")}
        </MDTypography>
      </DialogContent>

      <MDBox px={4} pb={3} display="flex" gap={1.5}>
        <MDButton
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={() => window.location.reload()}
          sx={{ borderRadius: 2 }}
          startIcon={<Icon>refresh</Icon>}
        >
          {t("buttonTitles.refresh") || "Refresh"}
        </MDButton>
        <MDButton
          variant="contained"
          fullWidth
          onClick={logOutHandler}
          sx={{ borderRadius: 2, bgcolor: palette.brand[500], "&:hover": { bgcolor: palette.brand[600] }, color: "#fff", "& .MuiButton-startIcon": { color: "#fff" } }}
          startIcon={<Icon sx={{ color: "#fff" }}>login</Icon>}
        >
          {t("session.login")}
        </MDButton>
      </MDBox>
    </Dialog>
  );
};

export default Refresh;
